import React from "react";

const AppstoreIcon = ({ theme }) => {
  return (
    <svg
      width="26"
      height="30"
      viewBox="0 0 26 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.4168 28.8C19.7834 30.3833 18.0001 30.1333 16.2834 29.3833C14.4668 28.6167 12.8001 28.5833 10.8834 29.3833C8.48344 30.4167 7.21678 30.1167 5.78344 28.8C-2.34989 20.4167 -1.14989 7.65 8.08344 7.18333C10.3334 7.3 11.9001 8.41667 13.2168 8.51667C15.1834 8.11667 17.0668 6.96667 19.1668 7.11667C21.6834 7.31667 23.5834 8.31667 24.8334 10.1167C19.6334 13.2333 20.8668 20.0833 25.6334 22C24.6834 24.5 23.4501 26.9833 21.4001 28.8167L21.4168 28.8ZM13.0501 7.08333C12.8001 3.36667 15.8168 0.3 19.2834 0C19.7668 4.3 15.3834 7.5 13.0501 7.08333Z"
        fill={theme === "dark" ? "white" : "#122549"}
      />
    </svg>
  );
};

export default AppstoreIcon;
